import { render, staticRenderFns } from "./PessoaDetalhes.vue?vue&type=template&id=3b1cf965"
import script from "./PessoaDetalhes.vue?vue&type=script&lang=js"
export * from "./PessoaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports